export default __webpack_public_path__ + "static/media/book5.246e36a3.svg";